import React from 'react';
import classNames from 'classnames';
import { makeStyles } from "../../styles/index";
import { Typography } from "../../index";
var styles = function (theme) { return ({
    root: {
        display: 'flex',
        height: '100%',
        width: '100%',
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.common.white,
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
            color: theme.palette.text.primary,
        },
    },
    rowIndex: {
        borderTop: "1px solid " + theme.palette.common.white,
        backgroundColor: theme.palette.light.background.default,
        color: theme.palette.light.text.primary,
        userSelect: 'none',
    },
    // 状態
    even: {
        backgroundColor: theme.palette.primary[50],
    },
    selected: {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.dark.text.primary,
        '&:hover': {
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.dark.text.primary,
        },
        '& > $rowIndex': {
            borderTop: "1px solid " + theme.palette.light.text.hint,
        },
    },
    blank: {
        '&$even': {
            '&:hover': {
                backgroundColor: theme.palette.primary[50],
                color: theme.palette.light.text.primary,
            },
        },
        '&:hover': {
            backgroundColor: theme.palette.common.white,
            color: theme.palette.light.text.primary,
        },
    },
}); };
var useStyles = makeStyles(styles, { name: 'SnDataListTableRow' });
export var DataListTableRow = function (props) {
    var _a;
    var columns = props.columns, cells = props.cells, fixedRowIndex = props.fixedRowIndex, rowData = props.rowData, rowIndex = props.rowIndex, selected = props.selected;
    var classes = useStyles();
    var rowClassName = classNames(classes.root, (_a = {},
        _a[classes.even] = rowIndex % 2,
        _a[classes.selected] = selected,
        _a[classes.blank] = rowData.blank,
        _a));
    return (React.createElement("div", { className: rowClassName }, columns.map(function (column, index) {
        var _a;
        var rowCellClassName = classNames((_a = {},
            _a[classes.rowIndex] = column.format === 'rowIndex' && fixedRowIndex,
            _a));
        return (React.createElement(Typography, { className: rowCellClassName, key: column.key }, cells[index]));
    })));
};
